<template>
  <el-menu  class="leftmenu"
      :collapse="isCollapse"
      router>
    <template v-for="(menu, menuIndex) in expertUserMenus">
      <el-menu-item :index="menu.path" :route="goRoute(menu)" :key="menu.path">
        <i class="el-icon-menu"></i>
        <span sloat="title">{{menu.title}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
  import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  export default {
    name: 'left',
    data() {
      return {
        subclsIcon: "el-icon-folder",
      }
    },
    computed: {
      ...mapGetters(['tabRoutes', 'reportsMenus', 'expertUserMenus', 'isCollapse']),
    },
    watch: {
    },
    methods: {
      closesubreport() {
        this.subclsIcon = 'el-icon-folder'
      },
      opensubreport() {
        this.subclsIcon = 'el-icon-folder-opened'
      },
      goRoute(menu) {
        let model = {path: menu.path, query: {menuid: menu.menuid, doctid: menu.doctid }}
        return model
      },
      goReportRoute(report) {
        let model = {path: '/bbzx/reportQuery',
          meta: {
            keepAlive: true,
            title: report.reportname
          },
          query: {reportid:report.reportid,title:report.reportname},
          params: {}
        }
        return model
      },
      handleSelect(key, keyPath) {
        //console.log(this.tabRoutes)
        //let func = this.tabRoutes.find(item => {return item.path === key})
        //console.log(func)
        //this.$store.commit('set_funcs', func)
      }
    }
  }
</script>
<style>
.leftmenu:not(.el-menu--collapse) {
    width: 150px;
    min-height: 560px;
  }
</style>
